
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/lendflo",
      function () {
        return require("private-next-pages/features/lendflo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/lendflo"])
      });
    }
  